// Repository vrstva (§24). BCF logika nesmí přímo pracovat s konkrétní databází.
// Rozhraní + in-memory implementace. IndexedDB / REST jsou další implementace (§25).
export class BCFRepository {
  async getTopics() { throw new Error("not implemented"); }
  async getTopic(_id) { throw new Error("not implemented"); }
  async saveTopic(_topic) { throw new Error("not implemented"); }
  async deleteTopic(_id) { throw new Error("not implemented"); }
}

// A. paměťová (výchozí, párováno s File mode / bcfzip).
export class MemoryBCFRepository extends BCFRepository {
  constructor() { super(); this._m = new Map(); }
  async getTopics() { return Array.from(this._m.values()); }
  async getTopic(id) { return this._m.get(id) || null; }
  async saveTopic(topic) { this._m.set(topic.id, topic); }
  async deleteTopic(id) { this._m.delete(id); }
}
